import { gsap } from 'gsap'

export default function () {
  const target = document.querySelector('.Animation')
  if (!target) return null

  const body = document.querySelector('body')
  const skyImage = target.querySelector('img.sky')
  const decoration = target.querySelector('.decoration')
  const lampostLightImage = target.querySelector('img.lights')
  const streetlights = gsap.utils.toArray('.streetlight')
  const clouds = gsap.utils.toArray('.cloud')
  const boats = gsap.utils.toArray('.boat')
  const buildingShader = document.querySelector('.building-shader')
  const cloud1 = target.querySelector('.cloud--1')
  const cloud2 = target.querySelector('.cloud--2')
  const cloud3 = target.querySelector('.cloud--3')
  const cloud4 = target.querySelector('.cloud--4')
  const cloud5 = target.querySelector('.cloud--5')
  const cloud6 = target.querySelector('.cloud--6')
  const cloud7 = target.querySelector('.cloud--7')

  // const windmillBlades = target.querySelector('.windmill--blades')

  // Current sky image number - accessible to all functions in this scope
  let currentPhase = 1

  const getCurrentPhase = () => {
    const now = new Date()
    const hour = now.getHours()
    if (hour >= 0 && hour < 6) {
      currentPhase = 6
      return 6
    }
    if (hour >= 6 && hour < 9) {
      currentPhase = 1
      return 1
    }
    if (hour >= 9 && hour < 11) {
      currentPhase = 2
      return 2
    }
    if (hour >= 11 && hour < 16) {
      currentPhase = 3
      return 3
    }
    if (hour >= 16 && hour < 19) {
      currentPhase = 4
      return 4
    }
    if (hour >= 19 && hour < 21) {
      currentPhase = 5
      return 5
    }
    if (hour >= 21 && hour < 24) {
      currentPhase = 6
      return 6
    }
    currentPhase = 1
    return 1
  }

  // const updateSkyImage = () => {
  //   const skyNumber = getCurrentPhase()
  //   const currentSrc = skyImage.getAttribute('src')

  //   // Extract filename from current src
  //   const parts = currentSrc.split('/')
  //   const currentFilename = parts.pop()

  //   // Build new filename only
  //   const newFilename = `sky_${skyNumber}.png`

  //   // Only update the filename if it changed
  //   if (currentFilename !== newFilename) {
  //     const newSrc = [...parts, newFilename].join('/')
  //     skyImage.setAttribute('src', newSrc)
  //   }
  // }

  const updateLights = () => {
    if (!lampostLightImage) return

    switch (currentPhase) {
      case 4:
      case 5:
      case 6:
        lampostLightImage.style.opacity = '1'
        break
      default:
        lampostLightImage.style.opacity = '0'
    }
  }

  const updateStreetLamps = () => {
    let streetlightOpacity = '0'
    switch (currentPhase) {
      case 5:
        streetlightOpacity = '0.4'
        startStreetlightFlicker()
        break
      case 6:
        streetlightOpacity = '0.7'
        startStreetlightFlicker()
        break
      default:
        streetlightOpacity = '0'
    }
    streetlights.forEach((streetlight) => {
      streetlight.style.opacity = streetlightOpacity
    })

    // Flicker Street light
    function startStreetlightFlicker() {
      function flickerRandomLight() {
        const light = gsap.utils.random(streetlights)

        // Flicker animation
        gsap.fromTo(
          light,
          { opacity: streetlightOpacity },
          {
            opacity: gsap.utils.random(0.2, 0.6),
            duration: 0.1,
            yoyo: true,
            repeat: gsap.utils.random(2, 4), // number of flickers
            ease: 'power1.inOut',
            onComplete: () => {
              // wait a few seconds, then flicker a new light
              gsap.delayedCall(gsap.utils.random(2, 5), flickerRandomLight)
            },
          },
        )
      }

      flickerRandomLight()
    }
  }

  const opacityClouds = () => {
    let cloudOpacity
    switch (currentPhase) {
      case 1:
        cloudOpacity = '0.5'
        break
      case 2:
      case 3:
        cloudOpacity = '1'
        break
      case 4:
        cloudOpacity = '0.3'
        break
      default:
        cloudOpacity = '0'
    }
    clouds.forEach((cloud) => {
      cloud.style.opacity = cloudOpacity
    })
  }

  const animateClouds = () => {
    if (currentPhase >= 1 && currentPhase <= 4) {
      function animateCloudWithRandomStart(
        el,
        duration,
        startPos,
        startDuration,
      ) {
        // 1. First pass starting from a random on-screen position
        gsap.fromTo(
          el,
          {
            x: startPos + 'vw', // random starting point
          },
          {
            x: '160vw',
            duration: startDuration,
            ease: 'none',
            onComplete: startLoop(duration), // move to the main loop
          },
        )

        function startLoop(duration) {
          gsap.fromTo(
            el,
            { x: '-25vw' }, // start off-screen left
            {
              x: '160vw', // move across off-screen right
              duration: duration,
              ease: 'none',
              repeat: -1,
              repeatDelay: gsap.utils.random(1, 4),
            },
          )
        }
      }

      // el, duration, startPos, startDuration
      animateCloudWithRandomStart(cloud1, 95, -4, 100)
      animateCloudWithRandomStart(cloud2, 120, 16, 110)
      animateCloudWithRandomStart(cloud3, 130, 27, 110)
      animateCloudWithRandomStart(cloud4, 90, 42, 55)
      animateCloudWithRandomStart(cloud5, 92, 53, 45)
      animateCloudWithRandomStart(cloud6, 91, 70, 70)
      animateCloudWithRandomStart(cloud7, 140, 80)
      opacityClouds()
    }
  }

  const opacityBuildingShaders = () => {
    let buildingOpacity
    switch (currentPhase) {
      case 4:
        buildingOpacity = '0.3'
        break
      case 5:
        buildingOpacity = '0.5'
        break
      case 6:
        buildingOpacity = '0.7'
        break
      default:
        buildingOpacity = '0'
    }
    buildingShader.style.opacity = buildingOpacity
  }

  const animateBoats = () => {
    if (currentPhase >= 1 && currentPhase <= 4) {
      const boat1 = target.querySelector('.boat--1')
      const boat2 = target.querySelector('.boat--2')
      // const boat3 = target.querySelector('.boat--3')
      const boat4 = target.querySelector('.boat--4')

      gsap.to(boat1, {
        x: '120vw',
        duration: gsap.utils.random(35, 40),
        ease: 'none',
        repeat: -1,
        repeatDelay: gsap.utils.random(8, 12),
        delay: gsap.utils.random(8, 12),
      })

      gsap.to(boat2, {
        x: '120vw',
        duration: gsap.utils.random(30, 35),
        ease: 'none',
        repeat: -1,
        repeatDelay: gsap.utils.random(8, 12),
      })

      // gsap.to(boat3, {
      //   x: '120vw',
      //   duration: gsap.utils.random(70, 77),
      //   ease: 'none',
      //   repeat: -1,
      //   repeatDelay: gsap.utils.random(8, 12),
      // })

      gsap.to(boat4, {
        x: '-130vw',
        duration: gsap.utils.random(22, 27),
        ease: 'none',
        repeat: -1,
        repeatDelay: gsap.utils.random(8, 12),
      })

      boats.forEach((boat) => {
        gsap.to(boat, {
          rotation: () => gsap.utils.random(-2, 2),
          y: () => '+=' + gsap.utils.random(2, 3),
          duration: gsap.utils.random(3.5, 4.5),
          yoyo: true,
          repeat: -1,
          ease: 'sine.inOut',
        })
      })
    } else {
      const staticBoats = gsap.utils.toArray('.staticBoat')
      staticBoats.forEach((staticboat) => {
        gsap.to(staticboat, {
          rotation: () => gsap.utils.random(-1, 1),
          y: () => '+=' + gsap.utils.random(1, 2),
          duration: gsap.utils.random(4.5, 5.5),
          yoyo: true,
          repeat: -1,
          ease: 'sine.inOut',
        })
      })
    }
  }

  // const spinWindmill = () => {
  //   gsap.to(windmillBlades, {
  //     duration: 40,
  //     rotation: '+=360',
  //     ease: 'none',
  //     repeat: -1,
  //   })
  // }

  function twinkleStars() {
    if (currentPhase == 6) {
      const stars1 = target.querySelector('.stars-1')
      const stars2 = target.querySelector('.stars-2')
      gsap.set(stars2, { opacity: 0 })

      gsap.to(stars1, {
        opacity: 0,
        duration: 2,
        yoyo: true,
        repeat: -1,
        repeatDelay: 0,
        ease: 'none',
      })

      gsap.to(stars2, {
        opacity: 1,
        duration: 2,
        yoyo: true,
        repeat: -1,
        repeatDelay: 0,
        ease: 'none',
      })
    }
  }

  const randomDecoration = () => {
    const currentSrc = decoration.getAttribute('src')
    const randomNumber = gsap.utils.random(1, 6, 1)

    const parts = currentSrc.split('/')
    const currentFilename = parts.pop()
    const newFilename = `decoration-${randomNumber}.png`

    // Only update the filename if it changed
    if (currentFilename !== newFilename) {
      const newSrc = [...parts, newFilename].join('/')
      decoration.setAttribute('src', newSrc)
    }
  }

  // Update sky image on initialization
  getCurrentPhase()
  updateLights()
  updateStreetLamps()
  opacityBuildingShaders()
  twinkleStars()
  randomDecoration()
  animateBoats()

  // Start once the page is ready
  window.addEventListener('load', animateClouds)

  document.documentElement.classList.add(`currentPhase--${currentPhase}`)
}
